import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, Container, Paper, TextField, Button } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginTop: '150px',
  },
  paper: {
    height: 500,
    width: 500,
  },
  form: {
    '& > *': {
      margin: theme.spacing(1),
      width: '30ch',
    },
  },
  txtfield: {
    marginLeft: '33%',
    paddingTop: '150px',
  },
  button: {
    flexDirection: 'column',
    marginLeft: '33%',
    width: '20ch',
  },
}));

const FormContainer = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async function (e) {
    e.preventDefault();
    console.log(`Submitting Email and Password ${email}, ${password}`);
    // const emailEl = document.querySelector('#email-field');
    // const passwordEl = document.querySelector('#password-field');
    fetch('api/user/login', {
      method: 'post',
      body: JSON.stringify({
        email: `${email}`,
        password: `${password}`,
      }),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function () {
        console.log('hello');
      })
      .catch((err) => console.log(err));
    //clear the fields
    // setEmail('');
    // setPassword('');
  };
  const classes = useStyles();
  return (
    <>
      <Container>
        <Grid container justify='center'>
          <Grid item className={classes.gridItem}>
            <Paper elevation={3} className={classes.paper}>
              <form className={classes.form} noValidate autoComplete='off'>
                <div className={classes.txtfield}>
                  <TextField
                    id='email-field'
                    label='EMAIL'
                    type='text'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    id='password-field'
                    label='PASSWORD'
                    type='text'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <Button
                  className={classes.button}
                  variant='contained'
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default FormContainer;
